import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/sign-up/[[...sign-up]]/SignUpClient.tsx");
